export default {
  LayersControl: "Layers",
  SettingsControl: "Settings",
  settings: {
    language: {
      title: "Language",
      German: "Deutsch",
      English: "English",
      Hungarian: "Magyar",
      Romanian: "Română"
    },
    clustering: {
      title: "Item clustering",
      always: "Always",
      never: "Never",
      dynamic: "Dynamic"
    },
    functions: {
      title: "Functions",
      print: "Print",
      measure: "Measure"
    },
    layerLabel: "Layer",
    transparency: "Transparency",
    dataPrivacy: "Imprint & Data Privacy",
    downloadMsg: "Download City App",
    legend: "Legend",
    backdrop: "Backdrop",
    embedLinks: "Embed-Links"
  },
  buttons: {
    fullscreen: "Toggle Fullscreen",
    popout: "Detach map",
    poisAndStreets: "Points of Interest",
    routing: "Routing",
    close: "Close",
    gps: "My Location",
    view3D: "View 3D",
    weather3D: "View weather 3D",
    streets: "Streets"
  },
  menuPopup: {
    back: "Back to results",
    pois: "Categories",
    streets: "Streets"
  },
  poiDetails: {
    moreInfo: "More information",
    openingHours: "Opening hours",
    opened: "Opened",
    closed: "Closed",
    showMore: "Show more",
    showLess: "Show less",
    altitude: "Altitude",
    zmin: "Min. Elevation",
    zmax: "Max. Elevation",
    distance: "Distance",
    time: "Time",
    content: "Content",
    ytitle: "Distance",
    xtitle: "Altitude"
  },
  measureComponent: {
    colorSelector: "Color",
    shape: "Shape",
    measure: "Measure",
    length: "Length",
    area: "Area",
    radius: "Radius",
    circumference: "Circumference",
    delete: "Delete all"
  },
  rightClickFrame: {
    startPoint: "Choose startpoint",
    endPoint: "Choose endpoint",
    whatIsHere: "What is here?",
    print: "Print",
    measure: "Measure"
  },
  routeFrame: {
    routeOptions: "Route options",
    highway: "Highways",
    tollRoad: "Toll roads",
    ferry: "Ferries",
    units: "Units",
    startPoint: "Startpoint ...",
    midPoint: "Midpoint ...",
    endPoint: "Endpoint ...",
    metric: "Metric (km)",
    imperial: "Imperial (mi)",
    via: "via",
    departure: "Departure:",
    details: "Details",
    error: "An error has occurred:",
    getDirections: "Go!",
    switchPoints: "Switch waypoints",
    close: "Close route view",
    directions_car: "Driving",
    directions_bus: "Transit",
    directions_bike: "Cycling",
    directions_walk: "Walking"
  },
  streetEntry: {num: "No."},
  searchPlaceholder: "Search for points of interest, streets or routes on the map ...         ",
  searchFrame: {
    previous: "previous",
    next: "next",
    loading: "Loading",
    error: "An error has occurred",
    noResults: "Sorry, no results found",
    // pois: "POIs",
    pois: "Places & Routes",
    streets: "Streets",
    other: "Other"
  },
  general: {
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    copy: "Copy to clipboard"
  },
  printOverlay: {
    titlePlaceholder: "Title (optional)",
    notesPlaceholder: "Notes (optional)",
    print: "Print",
    close: "Close",
    pleaseWait: "Please wait while your print is generated",
    pleaseWaitSubscript: "This might take several seconds."
  },
  gdpr: {
    title: "GDPR Notification",
    message:
      "This site collects anonymous statistics to improve the user experience. By pressing 'Ok' you consent to this analysis.",
    ok: "Ok",
    no: "No thanks"
  },
  wfs: {
    intro_description: "Please select an element on the map to view its details.",
    no_elem_found: "No element was found at this location.",
    unknown_error: "An unknown error occurred: "
  },
  routing: {
    title: "Routing",
    instructionsTitle: "Instructions",
    showMore: "Show more",
    showLess: "Show less",
    startPlaceholder: "Find start / click on map",
    endPlaceholder: "Find destination / click on map",
    useMyLocation: "Use My Location",
    needBothPoints: "Please select both a start and destination point to view instructions.",
    loading: "Loading route...", 
    startNavigation: "Start navigation",
    stopNavigation: "Stop navigation",
    enableVoice: "Enable voice guidance",
    disableVoice: "Disable voice guidance"
  },
  instructions: {
    roundabout: {icon: "sync", text: "Roundabout"},
    rotary: {icon: "sync", text: "Roundabout"},
    "turn sharp right": {icon: "turn_sharp_right", text: "Turn sharp right"},
    "turn sharp left": {icon: "turn_sharp_left", text: "Turn sharp left"},
    "turn slight right": {icon: "turn_slight_right", text: "Turn slight right"},
    "turn slight left": {icon: "turn_slight_left", text: "Turn slight left"},
    "turn right": {icon: "turn_right", text: "Turn right"},
    "turn left": {icon: "turn_left", text: "Turn left"},
    "keep right": {icon: "fork_right", text: "Keep right"},
    "keep left": {icon: "fork_left", text: "Keep left"},
    continue: {icon: "straight", text: "Continue"},
    "make a u-turn": {icon: "u_turn_left", text: "Make a U-turn"},
    "u-turn": {icon: "u_turn_left", text: "Make a U-turn"},
    waypoint: {icon: "place", text: "Waypoint"}
  },
  rotateOverlay: {
    message: "Please rotate your phone to portrait mode to view the map."
  },
  events: {
    title: "Event Calendar",
    allEvents: "All",
    loading: "Loading events...",
    noEvents: "There are no events in the selected month.",
    seeMore: "See more information",
    information: "Information about event",
    website: "Website",
    location: "Location"
  }
};
